// Auto-generated by splitter.py — do not regenerate; edit directly.

import React from 'react';
import { Calendar } from 'lucide-react';
import { EMAIL_TEMPLATES } from '../../data/comms';
import { AssignDesignToEventModal } from './AssignDesignToEventModal';
import { BRAND } from '../../lib/brand';

export const EmailPreviewCard = ({ template, blocks, text, eventLabel, venueLabel, dateLabel, size = 'md' }) => {
  const t = template || EMAIL_TEMPLATES[0];
  const txt = text || t.text || {};
  const b = blocks || t.blocks || {};
  const w = size === 'sm' ? 'max-w-[300px]' : 'max-w-[420px]';
  return (
    <div className={`${w} mx-auto bg-[#F2F1ED] border border-[#E6E4E1] rounded-md p-2`}>
      {b.preheader && <div className="text-[8.5px] text-[#9CA3AF] px-1 mb-1 truncate">{txt.preheader || 'Preview text…'}</div>}
      <div className="bg-white border border-[#E6E4E1] rounded overflow-hidden">
        {b.hero && (
          <div className="h-16 px-4 flex items-center justify-between" style={{ backgroundColor: t.headerColor }}>
            <div className="text-white text-[10px] uppercase tracking-[0.08em] opacity-80">{BRAND.name}</div>
            <div className="text-white text-[10px] opacity-60">Header image</div>
          </div>
        )}
        <div className="px-4 py-3">
          {b.headline && <div className="text-[13.5px] font-semibold text-[#1F2937] leading-tight mb-1">{txt.headline || 'Headline'}</div>}
          {b.subheadline && txt.subheadline && <div className="text-[11px] text-[#4B5563] leading-snug mb-3">{txt.subheadline}</div>}
          {b.ticketSummary && (
            <div className="bg-[#FBFAF7] border border-[#E6E4E1] rounded p-2 mb-2 flex items-center gap-2">
              {b.qrInline && <div className="w-9 h-9 border flex items-center justify-center text-[7px] flex-shrink-0" style={{ borderColor: t.accentColor, color: t.accentColor }}>QR</div>}
              <div className="flex-1 min-w-0 text-[10px]">
                <div className="font-medium text-[#1F2937]">2 × Regular</div>
                <div className="text-[#6B7280]">{eventLabel || 'Your event'}</div>
              </div>
            </div>
          )}
          {b.eventDetails && (
            <div className="text-[10px] text-[#4B5563] space-y-0.5 mb-2 border-l-2 pl-2" style={{ borderColor: t.accentColor }}>
              <div><span className="text-[#9CA3AF]">When</span> · {dateLabel || '24 May 2026, 19:00 EAT'}</div>
              <div><span className="text-[#9CA3AF]">Where</span> · {venueLabel || 'Mandela National Stadium'}</div>
            </div>
          )}
          {b.cta && txt.cta && (
            <button className="w-full text-white text-[11px] font-medium py-1.5 rounded mb-2" style={{ backgroundColor: t.accentColor }}>{txt.cta}</button>
          )}
          {b.addToCalendar && <div className="text-[9.5px] text-[#6B7280] mb-1.5">+ Add to Google / Apple Calendar</div>}
          {b.venue && <div className="text-[9.5px] text-[#6B7280] mb-1.5">📍 Directions · parking · gate map</div>}
          {b.organizer && <div className="text-[9.5px] text-[#6B7280] mb-1.5">Organized by · Federation of Uganda Football Associations</div>}
          {b.help && <div className="text-[9.5px] text-[#6B7280] mb-1.5">Need help? · support@tkt.ug</div>}
          {b.social && <div className="flex items-center gap-2 mt-1.5"><div className="w-4 h-4 rounded-full bg-[#E6E4E1]" /><div className="w-4 h-4 rounded-full bg-[#E6E4E1]" /><div className="w-4 h-4 rounded-full bg-[#E6E4E1]" /></div>}
        </div>
        {b.footer && txt.footer && (
          <div className="border-t border-[#EEEDEA] px-4 py-2 bg-[#FBFAF7]">
            <div className="text-[8.5px] text-[#9CA3AF] leading-snug">{txt.footer}</div>
          </div>
        )}
      </div>
    </div>
  );
};

/* AssignDesignToEventModal — supports 3 scopes (event / category / tournament) for tickets AND emails */
